import { Box, styled } from '@mui/material';

export const PageWrapper = styled(Box)(({ theme }) => ({
  backgroundImage: 'url(/assets/DesktopMotif.svg)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center top',
  backgroundSize: '100% auto',
  height: '100vh',
  width: '100%',
  padding: theme.spacing(8, 0, 0),

  [theme.breakpoints.up('sm')]: {
    paddingTop: theme.spacing(24),
  },

  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(28),
  },
}));

export const MobileContainer = styled(Box)({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
});

export const MobileHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: theme.spacing(18),
  padding: theme.spacing(6),
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  margin: theme.spacing(0, 6, 4),

  ['svg']: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },

  [theme.breakpoints.up('sm')]: {
    position: 'absolute',
    top: theme.spacing(18),
    right: theme.spacing(12),
    height: theme.spacing(6),
    margin: 0,
    zIndex: 2,

    ['svg']: {
      height: theme.spacing(6),
      width: 'auto',
    },
  },

  [theme.breakpoints.up('xl')]: {
    top: theme.spacing(24),
  },
}));

export const MobileLogoWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',

  ['svg']: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const DesktopLogoWrapper = styled(Box)(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));
